// Added by Sejune Oh on 2019-06-25
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC, RefObject } from 'react'
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import Intl from '@/helper/Intl'
import { ReactEmptyEvent } from '@/helper/define'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import MgmtComponentFormStyle from '@/styles/management/MgmtComponentFormStyle'
import { Typography, Button } from '@/components/_primes'
import Dialog from '@/components/common/Dialog'
import { MGMT_FORM_DIALOG_WIDTH } from '@/styles/Theme'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface UserControlFCProps extends WithStyles<typeof styles> {
  onToggleActiveBtnClick: ReactEmptyEvent
  onToggleAuth2BtnClick: ReactEmptyEvent
  onResetPwdBtnClick: ReactEmptyEvent
  onResetAuth2BtnClick: ReactEmptyEvent
  onRemoveClick: ReactEmptyEvent
  activated: boolean
  auth2_enabled: boolean
  dialogRef: RefObject<Dialog>
  onDialogConfirm: () => Promise<{}>
  onDialogCancel: () => Promise<{}>
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const UserControl: FC<UserControlFCProps> = ({ classes, activated, auth2_enabled, ...props }) => {
  const descRemove = Intl.getIntlText({ id: 'htmljs_react.mgmt.usercontrol.desc_remove' })
  const descResetPwd = Intl.getIntlText({ id: 'htmljs_react.mgmt.usercontrol.desc_reset_password' })
  const descReset2FA = Intl.getIntlText({ id: 'htmljs_react.mgmt.usercontrol.desc_reset_2fa' })
  const descStatus = Intl.getIntlText({ id: 'htmljs_react.mgmt.usercontrol.desc_status' })
  const desc2FAStatus = Intl.getIntlText({ id: 'htmljs_react.mgmt.usercontrol.desc_2fa_status' })
  const btnRemove = Intl.getIntlText({ id: 'htmljs_react.mgmt.usercontrol.btn_remove' })
  const btnReset2FA = Intl.getIntlText({ id: 'htmljs_react.mgmt.usercontrol.btn_reset_2fa' })
  const btnResetPwd = Intl.getIntlText({ id: 'htmljs_react.mgmt.usercontrol.btn_reset_password' })
  const activeBtnText = activated
    ? Intl.getIntlText({ id: 'htmljs_react.mgmt.usercontrol.btn_disabled' })
    : Intl.getIntlText({ id: 'htmljs_react.mgmt.usercontrol.btn_enabled' })
  const auth2BtnText = auth2_enabled
    ? Intl.getIntlText({ id: 'htmljs_react.mgmt.usercontrol.btn_disabled' })
    : Intl.getIntlText({ id: 'htmljs_react.mgmt.usercontrol.btn_enabled' })
  return (
    <div className={classes.CtrWrapper}>
      
      <div className={classes.ControlBtnWrapper}>
        <Typography variant='body1' className={classes.ControlTextWrapper}>
          {descStatus}
        </Typography>
        <Button
          color={'default'}
          onClick={props.onToggleActiveBtnClick}
          btnText={activeBtnText}
          data-cy-btn='toggleActive'
        />
      </div>
      <div className={classes.ControlBtnWrapper}>
        <Typography variant='body1' className={classes.ControlTextWrapper}>
          {desc2FAStatus}
        </Typography>
        <Button
          color={'default'}
          onClick={props.onToggleAuth2BtnClick}
          btnText={auth2BtnText}
          data-cy-btn='toggleActive'
        />
      </div>
      <div className={classes.ControlBtnWrapper}>
        <Typography variant='body1' className={classes.ControlTextWrapper}>
          {descReset2FA}
        </Typography>
        <Button
          color={'default'}
          onClick={props.onResetAuth2BtnClick}
          btnText={btnReset2FA}
          data-cy-btn='toggleActive'
        />
      </div>
      <div className={classes.ControlBtnWrapper}>
        <Typography variant='body1' className={classes.ControlTextWrapper}>
          {descResetPwd}
        </Typography>
        <Button onClick={props.onResetPwdBtnClick} btnText={btnResetPwd} data-cy-btn='resetPw' />
      </div>
      <div className={classes.ControlBtnWrapper}>
        <Typography variant='body1' className={classes.ControlTextWrapper}>
          {descRemove}
        </Typography>
        <Button onClick={props.onRemoveClick} buttonType='danger' btnText={btnRemove} data-cy-btn='removeUser' />
      </div>
      <Dialog
        ref={props.dialogRef}
        onConfirm={props.onDialogConfirm}
        onCancel={props.onDialogCancel}
        dialogPaperStyle={{ minWidth: MGMT_FORM_DIALOG_WIDTH }}
      />
    </div>
  )
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const styles = (theme: Theme) =>
  createStyles({
    ...MgmtComponentFormStyle(theme),
  })

export default withStyles(styles, { withTheme: true })(UserControl)

